import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-acab0860"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "headers" }
const _hoisted_2 = { class: "key" }
const _hoisted_3 = { class: "value" }

import { computed } from 'vue';

interface KeyValuePair
{
    key: string;
    value: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageHeaders',
  props: {
    headers: {
        type: Object,
        required: true
    }
},
  setup(__props) {

const props = __props




const keyValues = computed<KeyValuePair[]>(() =>
{
    const result: KeyValuePair[] = [];

    for (let key of Object.keys(props.headers))
        result.push({ key, value: props.headers[key] });

    return result;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(keyValues), (pair) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: pair.key
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(pair.key), 1),
        _createElementVNode("span", _hoisted_3, _toDisplayString(pair.value), 1)
      ], 64))
    }), 128))
  ]))
}
}

})